







import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { UCIcon } from '@shared/ui';

export default defineComponent({
  name: 'ButtonPrimary',
  components: {
    UCIcon,
  },
  props: {
    onClick: {
      type: Function as PropType<() => void>,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
  },
});
